import React, { useEffect } from "react";
import Header from "../components/header";
import Footer from "../components/footer";
import HomeComp from "../components/home-comp";

function ContactUs() {
  useEffect(() => {
    // 1. Script load karne ka helper function (Promise ke sath)
    const loadScript = (src) => {
      return new Promise((resolve, reject) => {
        // Check agar script pehle se exist karti hai to dubara load na kare
        if (document.querySelector(`script[src="${src}"]`)) {
          resolve();
          return;
        }

        const script = document.createElement("script");
        script.src = src;
        script.async = false; // Isko false rakhna zaroori hai sequence ke liye
        
        script.onload = () => resolve();
        script.onerror = () => reject(new Error(`Script load failed: ${src}`));

        document.body.appendChild(script);
      });
    };

    // 2. Scripts ki list (Order bohot important hai)
    const scripts = [
      "assets/js/jquery.js",            // Sabse pehle Base Library
      "assets/js/bootstrap.bundle.min.js",
      "assets/js/purecounter.js",
      "assets/js/range-slider.js",
      "assets/js/nice-select.js",
      "assets/js/swiper-bundle.min.js",
      "assets/js/isotope-pkgd.js",
      "assets/js/slick.min.js",
      "assets/js/wow.js",
      "assets/js/countdown.js",
      "assets/js/magnific-popup.js",
      "assets/js/imagesloaded-pkgd.js",
      "assets/js/parallax.js",
      "assets/js/slider.js",
      "assets/js/main.js"               // Sabse last mein Main logic
    ];

    // 3. Async function jo scripts ko wait kar-kar ke load karega
    const loadAllScripts = async () => {
      try {
        for (const src of scripts) {
          await loadScript(src); // Jab tak yeh load nahi hoga, loop aage nahi barhega
        }
        console.log("All scripts loaded successfully");
      } catch (error) {
        console.error(error);
      }
    };

    loadAllScripts();

    // Cleanup function
    return () => {
      scripts.forEach(src => {
        const script = document.querySelector(`script[src="${src}"]`);
        if (script) {
          document.body.removeChild(script);
        }
      });
    };
  }, []);

  return (
    <>
      <Header />
      <HomeComp />
      <Footer />
    </>
  );
}

export default ContactUs;